import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { TariffOptions } from '../enums/tariff-options.enum';

@Component({
  selector: 'app-tariff-setup-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterOutlet],
  templateUrl: './tariff-setup-menu.component.html',
  styleUrl: './tariff-setup-menu.component.scss',
})
export class TariffSetupMenuComponent {
  selectedItem: string = 'tariff-setup';
  item = TariffOptions;

  constructor(private router: Router) {}

  toggleModal(item: TariffOptions) {
    this.selectedItem = item;
    this.router.navigate([item]);
  }
}
